import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SectionsA from './components/SectionsA';
import SectionsB from './components/SectionsB';
import SectionsC from './components/SectionsC';
import SectionsD from './components/SectionsD';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main>
        <HeroSection />
        <SectionsA />
        <SectionsB />
        <SectionsC />
        <SectionsD />
      </main>

      <Footer />
    </div>
  );
}